
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingPulse',
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
})

